import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infection-control-planing',
  templateUrl: './infection-control-planing.component.html',
  styleUrls: ['./infection-control-planing.component.css']
})
export class InfectionControlPlaningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  // Plan model
  plan = {
    name: '',
    description: '',
    selectedCategory: null,
    selectedSubcategory: null,
    selectedInterventions: [],
    responsiblePerson: '',
    timeline: '',
    progress: 0
  };

  // Categories and data (populate this with your actual categories, subcategories, and interventions)
  categories: any[] = [
    // Sample structure
    {
      name: 'Hand Hygiene',
      subcategories: [
        {
          name: 'Proper Handwashing Technique',
          interventions: ['Ensure staff wash hands for at least 20 seconds.', 'Focus on cleaning fingertips, nails, and between fingers.']
        }
      ]
    }
  ];

  // Toggle intervention selection
  toggleIntervention(intervention: string) {
    const index = this.plan.selectedInterventions.indexOf(intervention);
    if (index === -1) {
      this.plan.selectedInterventions.push(intervention);
    } else {
      this.plan.selectedInterventions.splice(index, 1);
    }
  }

  // Submit plan logic
  submitPlan() {
    // Here you can handle the submission of the plan, e.g., send it to a backend API, save it locally, etc.
    console.log('Plan Submitted:', this.plan);
  }
}
